import axios from 'axios';

import { parsePublicKeysForUI } from './publicKeys.parsers';
import type { PublicKeys, PublicKeysDto } from './publicKeys.types';

const endpoint = 'public_keys/';

const publicKeysApi = {
  get: () => async (): Promise<PublicKeys> => {
    const { data } = await axios.get<PublicKeysDto>(endpoint);
    return parsePublicKeysForUI(data);
  },
};

export default publicKeysApi;
